export default __webpack_public_path__ + "f4d43108b570af9c9893f36dccb2b3c5.png";